import { ChangeDetectionStrategy, Component, Signal, computed, inject } from '@angular/core';
import { ROUTER_OUTLET_DATA } from '@angular/router';
import { BuildingLayoutData } from './building-layout-data';

/**
 * Abstract base class for building layout pages.
 *
 * This class provides access to the building layout data injected via the ROUTER_OUTLET_DATA token.
 */
@Component({
  template: '',
  selector: 'cfp-building-layout-page-base',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export abstract class BuildingLayoutPageBase {
  private readonly innerBuildingLayoutData: Signal<BuildingLayoutData | null> = inject(
    ROUTER_OUTLET_DATA
  ) as Signal<BuildingLayoutData | null>;

  protected readonly portfolioId = computed(() => this.innerBuildingLayoutData()?.portfolioId);
  protected readonly buildingId = computed(() => this.innerBuildingLayoutData()?.buildingId);
  protected readonly building = computed(() => this.innerBuildingLayoutData()?.building);
  protected readonly labelGroup = computed(() => this.innerBuildingLayoutData()?.labelGroup);
  protected readonly labelGroups = computed(() => this.innerBuildingLayoutData()?.labelGroups);
  protected readonly currentLabel = computed(() => this.innerBuildingLayoutData()?.currentLabel);
  protected readonly tabbar = this.innerBuildingLayoutData()?.tabbar;
}
